import {
    get,
    post
} from '@/utils/request'

const SERVICE_URL = '/order-service/v1'

export function deleteBatch(params, pathParam) {
    return get(SERVICE_URL + '/account/deleteBatch', params, pathParam)
}
export function queryById(params, pathParam) {
    return get(SERVICE_URL + '/account/getById', params, pathParam)
}
export function list(params) {
    return post(SERVICE_URL + '/account/list', params)
}
export function add(params) {
    return post(SERVICE_URL + '/account/add', params)
}
export function edit(params) {
    return post(SERVICE_URL + '/account/editAccount', params)
}



export function deletePartBatch(params, pathParam) {
    return get(SERVICE_URL + '/accountPartList/deleteBatch', params, pathParam)
}
export function queryPartById(params, pathParam) {
    return get(SERVICE_URL + '/accountPartList/getById', params, pathParam)
}
export function listPart(params) {
    return post(SERVICE_URL + '/accountPartList/list', params)
}
export function addPart(params) {
    return post(SERVICE_URL + '/accountPartList/add', params)
}
export function editPart(params) {
    return post(SERVICE_URL + '/accountPartList/edit', params)
}
//结算单查询导出
export function exportSettlementData(params) {
    return post(SERVICE_URL + '/upload-file/exportSettlementData', params)
}
//补发邮件
export function pushEmail(params) {
    return post(SERVICE_URL + '/account/pushEmail', params)
}